export const i18nDriver = function (i18n) {
  return {
    get locale () {
      return i18n._language
    },
    set locale (val) {
      i18n.activate(val)
    },
    getMessage (_, key, data, field) {
      let id = `validation.specialized_messages.${field}.${key}`
      var replace = {}
      replace[key] = data[1][0]
      let specializedMsg = i18n.t(id, replace)
      if (specializedMsg !== id) return specializedMsg
      id = `validation.messages.${key}`
      return i18n.t(id, replace)
    },
    setMessage (locale, key, value) {
      i18n.load({
        [locale]: {
          messages: {
            [`validation.messages.${key}`]: value
          }
        }
      })
    },
    getAttribute (_, key) {
    },
    setAttribute (locale, attr, value) {
    },
    getFieldMessage (_, field, rule, data) {
      return this.getMessage(_, rule, data, field)
    },
    merge (dictionary) {
    },
    getDateFormat (locale) {
    },
    setDateFormat (locale, format) {
    }
  }
}
